module.exports = __webpack_public_path__ + "static/img/htjs3.65c1160.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/htjs3.png
// module id = hkMd
// module chunks = 1